import { common } from "./common";
import { dashboard } from "./dashboard";
import { tenants } from "./tenants";
import { tenantDetail } from "./tenant-detail";
import { usage } from "./usage";
import { plans } from "./plans";
import { aiModels } from "./ai-models";
import { system } from "./system";
import { support } from "./support";
import { audit } from "./audit";
import { staff } from "./staff";
import { settings } from "./settings";
import { customPlan, manualBilling, salesRequests } from "./sales-requests";

/** Platform admin screens (P9). One file per screen; `common` holds shared dialogs + gates. */
export const adminScreens = {
  common,
  dashboard,
  tenants,
  tenantDetail,
  usage,
  plans,
  aiModels,
  system,
  support,
  audit,
  staff,
  settings,
  salesRequests,
  manualBilling,
  customPlan,
} as const;
